// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-2e488f50]{background:var(--neutral-surface-page);height:var(--spacing-72)}header nav[data-v-2e488f50]{padding:0 36px}header .end-side[data-v-2e488f50]{gap:var(--spacing-3xl)}header .end-side.auth[data-v-2e488f50]{gap:var(--spacing-32)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
